import { FunctionComponent } from "react";
import Navbar1 from "../components/Navbar1";
import NewUsedFrame from "../components/NewUsedFrame";

const Store: FunctionComponent = () => {
  return (
    <div className="w-full relative bg-white overflow-hidden flex flex-col items-start justify-start pt-0 px-0 pb-[2739px] box-border tracking-[normal]">
      <Navbar1 />
      <NewUsedFrame />
    </div>
  );
};

export default Store;
